/**
 * Read a File as a data URL (data:image/...;base64,...).
 */
export function fileToDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if(typeof reader.result === 'string') {
                resolve(reader.result);
                return;
            }
            reject(new Error('failed to read file'));
        };
        reader.onerror = () => reject(reader.error || new Error('failed to read file'));
        reader.readAsDataURL(file);
    });
}

const IMAGE_MIME_RE = /^image\/(jpeg|jpg|png|webp)$/i;

export function isAiAgentVisionImage(file: File): boolean {
    return IMAGE_MIME_RE.test(file.type);
}

/** Soft cap before base64 (~8MB raw ≈ ~11MB JSON). */
export const AI_AGENT_MAX_IMAGE_BYTES = 8 * 1024 * 1024;
